import axios from 'axios';
import { useContext, useRef } from 'react';
import { SmartContext } from '../Core/SmartContext';
import { evaluateExpression, getControlValueFromState, handleControlValueChange } from '../Core/SmartFunctions';
import { SimpleFormControlArguments, State } from '../Core/SmartTypes';
import logger from '../Core/logger';
import { axiosClient } from '../Service/axiosClient';
import ErrorControl from './ErrorControl';

const FileControl = (args: SimpleFormControlArguments) => {
    const { state, dispatch } = useContext(SmartContext);
    const { control, dataKey, parentDataKey } = { ...args };
    const data = getControlValueFromState(dataKey, state as State);
    const formControlRef = useRef(null); // Note: For providing reference to ErrorControl
    const isHidden = evaluateExpression(control.hideExpression, state?.data);

    const accept: string | undefined = control.props?.accept;

    const isFileAccepted = (file: File): boolean => {
        if (!accept) return true;
        const patterns = accept.split(',').map((p) => p.trim().toLowerCase()).filter(Boolean);
        const fileType = (file.type || '').toLowerCase();
        const fileName = (file.name || '').toLowerCase();
        return patterns.some((p) => {
            if (p.startsWith('.')) return fileName.endsWith(p);
            if (p.endsWith('/*')) return fileType.startsWith(p.slice(0, -1));
            return fileType === p;
        });
    };

    const handleFileControlUpload = async (state: State, e: any) => {
        logger.log(state.data);
        console.log(e.target.files);

        if (e.target.files != null && e.target.files.length > 0) {
            const file = e.target.files[0];

            if (!isFileAccepted(file)) {
                alert(`Only ${accept} files are allowed.`);
                e.target.value = '';
                return;
            }

            const apiUrl = `${process.env.REACT_APP_COMMON_API}/upload/upload-file`;
            const formData = new FormData();
            formData.append('pdf_doc', file);

            const response = await axiosClient().post(apiUrl, formData);
            let link = response.data.link;
            handleControlValueChange({ control, value: link, dataKey, parentDataKey, state, dispatch });
        }
    };

    if (isHidden) return <></>;
    const handleUpload = async (e: any) => {};

    const getFileName = (fileUrl: string): string => {
        if (!fileUrl) return '';
        try {
            const parsedUrl = new URL(fileUrl);
            return decodeURIComponent(parsedUrl.pathname.split('/').filter(Boolean).pop() ?? fileUrl);
        } catch {
            return decodeURIComponent(fileUrl.split('/').filter(Boolean).pop() ?? fileUrl);
        }
    };

    const fileName = Array.isArray(data)
        ? getFileName(data[0])
        : typeof data === 'string'
        ? getFileName(data)
        : '';

    return (
        <div className="w-100">
            <label htmlFor="formFileLg" className="form-label">
                {control.props.label}
            </label>

            <input
                id={control.id}
                data-testid={control.id}
                type="file"
                accept={accept}
                hidden={control.props?.isCode || isHidden}
                className={`form-control form-control-lg pl-0`}
                name="cover"
                onChange={(event) => handleFileControlUpload(state as State, event)}
            />
            {fileName && (
                <div className="uploaded-file-name mt-2">
                    <span className="text-muted">Uploaded file:</span> {fileName}
                </div>
            )}
            <ErrorControl errorMessages={state?.formValidationErrors[dataKey]} />
        </div>
    );
};

export default FileControl;
